export type InvalidDate = Date

export function dateIsValid(date: Date): date is InvalidDate {
  return !Number.isNaN(date.getTime())
}
